function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M41.1 67H6a3 3 0 01-3-3V28.9a3 3 0 013-3h14v6H9V61h29.1V50h6v14a3 3 0 01-3 3zM64 44.1H49.29v-6H61V9H31.9v11.71h-6V6a3 3 0 013-3H64a3 3 0 013 3v35.1a3 3 0 01-3 3z",
  fill: "#dce1ec"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41 25.9H25v6h8.72L21.38 44.28l4.24 4.24L38 36.15v8.72h6v-16a3 3 0 00-3-2.97z",
  fill: "#23c386"
});

function SvgCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MCA3MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkY2UxZWN9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDEuMSA2N0g2YTMgMyAwIDAxLTMtM1YyOC45YTMgMyAwIDAxMy0zaDE0djZIOVY2MWgyOS4xVjUwaDZ2MTRhMyAzIDAgMDEtMyAzek02NCA0NC4xSDQ5LjI5di02SDYxVjlIMzEuOXYxMS43MWgtNlY2YTMgMyAwIDAxMy0zSDY0YTMgMyAwIDAxMyAzdjM1LjFhMyAzIDAgMDEtMyAzeiIvPjxwYXRoIGQ9Ik00MSAyNS45SDI1djZoOC43MkwyMS4zOCA0NC4yOGw0LjI0IDQuMjRMMzggMzYuMTV2OC43Mmg2di0xNmEzIDMgMCAwMC0zLTIuOTd6IiBmaWxsPSIjMjNjMzg2Ii8+PC9zdmc+";
export { SvgCustomer as ReactComponent };